import React from "react";
import {
    Card,
    Modal,
    Button,
    Statistic,
    Icon,
    Popover,
    Tabs,
    message,
    Select,
    Col,
    Typography
} from "antd";
import moment from "moment";
import { formatCurrency } from "utilities/currency";
import { OrderedMap, List, Map } from "immutable";
import PropTypes from "prop-types";
import Clipboard from "assets/clipboard.png";
import { Table } from "components";
import BankStatementUploadForm from "forms/bank-statement-upload-form";
import BankStatementUploadFormPerfios from "forms/bank-statement-upload-form-perfios";
import BankStatementMannualForm from "forms/bank-statement-analysis-mannual-form";
import CaseService from "services/case-service";
import { BANK_STATEMENT_ANALYSER_STATUS, PERFIOS_BANK_STATEMENT_ANALYSER_STATUS } from "constants/enums";
import Datasheet from "react-datasheet";
import "styles/bank-statement-analysis.css";
const { Title: Paragraph } = Typography;

const { TabPane } = Tabs;

const getJobListCols = () => new OrderedMap({
    analysis_request: {
        key: "analysis_request",
        dataIndex: "analysis_request",
        title: "Request Id",
        // eslint-disable-next-line react/display-name
        render: _ => _,
        align: "center"
    },
    bank: {
        key: "bank",
        dataIndex: "bank",
        title: "Bank",
        align: "center"
    },
    create_date: {
        key: "create_date",
        dataIndex: "create_date",
        title: "Create Date",
        render: _ => _ && _.format("DD MMM YYYY"),
        align: "center"
    },
    provider: {
        key: "provider_name",
        dataIndex: "provider_name",
        title: "Provider",
        // eslint-disable-next-line react/display-name
        // render: _ => _?"Perfios":"Finnov",
        align: "center"
    },
    action: {
        key: "action",
        dataIndex: "action",
        title: "Action",
        align: "center"
    },
    current_status: {
        key: "current_status",
        dataIndex: "current_status",
        title: "Current Status",
        render: (_, props) => props.provider? _ === 4?<span style={{color: "red"}}>{PERFIOS_BANK_STATEMENT_ANALYSER_STATUS.findKey(__ => __ == _)}</span>:<span style={{color: _ === 5 ? "green":null}}>{PERFIOS_BANK_STATEMENT_ANALYSER_STATUS.findKey(__ => __ == _)}</span>:_ === 4?<span style={{color: "red"}}>{BANK_STATEMENT_ANALYSER_STATUS.findKey(__ => __ == _)}</span>:<span style={{color: _ === 5 ? "green":null}}>{BANK_STATEMENT_ANALYSER_STATUS.findKey(__ => __ == _)}</span>,
        align: "center"
    },
    download: {
        key: "download",
        dataIndex: "download",
        title: "Download Bank statement",
        align: "center"
    },
    using: {
        key: "using",
        dataIndex: "using",
        title: "Using",
        render: _ => _ ? "Yes" : "No",
        align: "center"
    },
    error: {
        key: "error",
        dataIndex: "error",
        title: "Bank Statement Analysis",
        align: "center"
    }
});

const ANALYSIS_TABLE = new OrderedMap({
    month: {
        title: "Months",
        key: "month",
        dataIndex: "month",
        render: _ => _ ? moment(_, "YYYYMM").format("MM-YYYY") : "--"
    },
    monthlyAverageBalanceOn10th: {
        title: "10th Balance",
        key: "monthlyAverageBalanceOn10th",
        dataIndex: "monthlyAverageBalanceOn10th",
        render: _ => _ && formatCurrency(_)
    },
    monthlyAverageBalanceOn15th: {
        title: "15th Balance",
        key: "monthlyAverageBalanceOn15th",
        dataIndex: "monthlyAverageBalanceOn15th",
        render: _ => _ && formatCurrency(_)
    },
    monthlyAverageBalanceOn20th: {
        title: "20th Balance",
        key: "monthlyAverageBalanceOn20th",
        dataIndex: "monthlyAverageBalanceOn20th",
        render: _ => _ && formatCurrency(_)
    },
    monthlyAverageBalanceOn25th: {
        title: "25th Balance",
        key: "monthlyAverageBalanceOn25th",
        dataIndex: "monthlyAverageBalanceOn25th",
        render: _ => _ && formatCurrency(_)
    },
    monthlyContraDebit: {
        title: "Inward Cheques Bounce",
        key: "monthlyContraDebit",
        dataIndex: "monthlyContraDebit",
        render: _ => _ ? (typeof _ != "object" ? 1 : (_.length || "--")) : 0  
    },
    monthlyContraCredit: {
        title: "Outward Cheques Bounce",
        key: "monthlyContraCredit",
        dataIndex: "monthlyContraCredit",
        render: _ => _ ? (typeof _ != "object" ? 1 : (_.length || "--")) : 0
    },
    monthlyTotalCredits: {
        title: "Monthly Credits",
        key: "monthlyTotalCredits",
        dataIndex: "monthlyTotalCredits",
        render: _ => _ && formatCurrency(_)
    },
    monthlyTotalDebits: {
        title: "Monthly Debits",
        key: "monthlyTotalDebits",
        dataIndex: "monthlyTotalDebits",
        render: _ => _ && formatCurrency(_)
    }
});

class BankStatementAnalyser extends React.Component {

    ANALYSIS_LIST = new OrderedMap({
        monthlyAvgBalance: {
            label: "Average Monthly Balance",
            value: 0,
            formula: null
        },
        sixMonthAvgInwardBouncingPercent: {
            label: "Inward Cheque Bounce (%)",
            value: 0,
            formula: "No. of Inward cheque bounced / Total no. of cheque recieved"
        },
        sixMonthAvgOutwardBouncingPercent: {
            label: "Outward Cheque Bounce (%)",
            value: 0,
            formula: "No. of Outward cheque bounced / Total no. of cheque issued"
        },
        monthlyNumberOfContraEmi: {
            label: "No EMI bounce",
            value: 0,
            formula: "formula"
        },
        monthlyDebitRunningAvgWithReturns: {
            label: `Average monthly debits of last ${this.props.bankCode === "KSF" ? "3" : "6"} months`,
            value: 0,
            formula: "formula"
        },
        monthlyCreditRunningAvgWithReturns: {
            label: `Average monthly credits of last ${this.props.bankCode === "KSF" ? "3" : "6"} months`,
            value: 0,
            formula: "formula"
        }
    });

    state = {
        uploadFiles: false,
        files: null,
        banks: [],
        perfiosBanks: [],
        selectedJob: null,
        analysisTypeList: new Map({}),
        activeKey: "1",
        data: [],
        perfios: true,
        updatedChequeval: {}
    };

    componentDidMount() {
        CaseService.getMasterBankListPerfios("Perfios").then(_ => {
            this.setState({
                perfiosBanks: _.data
            });
        }).catch(() => {});
        CaseService.getAnalysisTypeOptions().then(({ data }) => {
            this.setState({
                analysisTypeList: new Map(data)
            });
        }).catch(() => {});
    }

    componentDidUpdate() {
        const jobListStatus = this.props.bankStatementAnalyser && this.props.bankStatementAnalyser.getIn(["jobList", "status"]);
        const jobList = this.props.bankStatementAnalyser && this.props.bankStatementAnalyser.getIn(["jobList", "data"]);
        if(jobListStatus === "FETCHED" && (jobList.size || jobList.length) && !this.state.selectedJob) {
            let usedJob = jobList.find(_ => _.using);
            if(usedJob) {
                this.action(usedJob && usedJob.analysis_request);
                this.props.fetchStatementAnalysis(this.props.caseId, usedJob && usedJob.analysis_request);
            }
        }
    }

    toggleUploadModal = () => {
        this.setState({
            uploadFiles: !this.state.uploadFiles,
            perfios: true
        });
        CaseService.getMasterBankListPerfios("Perfios").then(_ => {
            this.setState({
                perfiosBanks: _.data
            });
        }).catch(() => {});
    }

    uploadBankStatements = (values) => {
        let data = new FormData();
        values.files.map(_ => {
            data.append("file", _);
        });
        data.append("bank_id", values.bank_id);
        data.append("case_id", this.props.caseId);
        data.append("account_type", values.account_type);
        data.append("from_date", values.from_date.format('YYYY-MM-DD'));
        data.append("to_date", values.to_date.format('YYYY-MM-DD'));
        data.append("company_id", this.props.companyId);
        data.append("document_source", 3);
        
        if(values.password_protected === "yes"){
            data.append("password", values.password);
        }
        if(this.state.perfios){
            data.append("provider", true);
            this.props.createProfiosRequest(this.props.caseId, data);
        }else{
            data.append("provider", false);
            this.props.createRequest(this.props.caseId, data);
        }
        this.setState({
            uploadFiles: false
        });
    }

    submitAnalysisDetail = (values) => {
        message.loading("Creating Request", 0);
        CaseService.createStatementAnalysis({...values, case_id: this.props.caseId}).then(() => {
            message.destroy();
            message.success("Job created successfully!");
            this.props.fetchJobsList(this.props.caseId);
        }).catch(() => {
            message.destroy();
            message.error("Failed to create Job");
        });
        this.setState({
            uploadFiles: false
        });
    }

    onRemove = () => {}

    onChangeFiles = ({ fileList }) => {
        this.setState({
            files: fileList
        });
    }

    action = (_) => {
        const filterData = this.props.bankStatementAnalyser.getIn(["jobList", "data"]).toJS().filter((item) => {
            return item.analysis_request == _;
        });
        this.setState({
            selectedJob: _
        }, () => {
            if(filterData[0] && filterData[0].provider){
                this.props.fetchStatementAnalysisPerfois(this.props.caseId, _);
            }else{
                this.props.fetchJobsDetails(this.props.caseId, _);
                this.props.fetchStatementAnalysis(this.props.caseId, _);
            }
            filterData[0] && BANK_STATEMENT_ANALYSER_STATUS.findKey(__ => __ == filterData[0].current_status) == "Failed" ? message.error(BANK_STATEMENT_ANALYSER_STATUS.findKey(__ => __ == filterData[0].current_status)):message.success(BANK_STATEMENT_ANALYSER_STATUS.findKey(__ => __ == filterData[0].current_status));
        });
    }

    JobListCols = getJobListCols(this.action);

    getNoDataCard = () => {
        return(
            <Card className={"padless-card"}>
                <div className={"p-10 d-flex justify-content-space-between align-items-center"}>
                    <div className={"fb-50 d-flex flex-row align-items-center"}>
                        <div className={"mr-5"}>
                            <img src={Clipboard} width={"120px"} />
                        </div>
                        <div style={{"color": "#333333 solid"}} className={"d-flex flex-column"}>
                            <span style={{
                                fontSize: "20px",
                                fontWeight: "600"
                            }}>{"No Data Found"}</span>
                            <span style={{
                                fontSize: "12px",
                                fontStyle: "light"
                            }}>
                                {"No Bank Statements have been uploaded yet, please Upload the statements here."}
                            </span>
                        </div>
                    </div>
                    {this.props.isSummary && this.props.recreditViewOnlyPermission ? null : <Button onClick={this.toggleUploadModal} type={"primary"} icon={"upload"}>
                        {"Upload Bank Statements"}
                    </Button>}
                </div>
            </Card>
        );
    }

    getTitle = (label, formula) => {
        return (
            <span>
                {label}
                <Popover content={formula} style={{
                    padding: "5px"
                }}>
                    <Icon style={{ marginLeft: "5px" }} type="eye" />
                </Popover>
            </span>
        );
    }

    headersGenerator() {
        this.headers = ANALYSIS_TABLE
            .toList()
            .map(_ => ({
                value: _.title,
                readOnly: true
            }))
            .toArray();
        return this.headers;
    }

    rowDataGenerator(_) {
        const arr = [];
        ANALYSIS_TABLE.mapKeys(k => {
            if (k === "month") {
                arr.push({
                    value: moment(_[k], "YYYYMM").format("MM-YYYY"),
                    key: k,
                    id: k,
                    readOnly: true
                });
                return;
            } else {
                arr.push({
                    value: _[k] ? String(_[k]) : "--",
                    id: k,
                    key: k,
                    readOnly: true
                });
            }
        });
        return arr;
    }

    generateStatementSpreadsheet() {
        if (
            new Map(this.finalData) &&
            new Map(this.finalData).size > 0 &&
            this.state.data.length === 0
        ) {
            this.setState({
                data: [
                    this.headersGenerator(),
                    ...new Map(this.finalData)
                        .toList()
                        .map(this.rowDataGenerator)
                        .toArray()
                ]
            });
        }
    }

    getAnalysisData = () => {
        const { bankStatementAnalyser } = this.props;
        const stats = bankStatementAnalyser && bankStatementAnalyser.getIn(["statementAnalysis", this.state.selectedJob, "data"]);
        let data = stats?.analysis_summary;
        if(data) {
            const keys = Object.keys(data);
            let maxMonthsData = Object.keys(data[keys[0]]);
            keys?.map(index=>{
                Object.keys(data[index])?.length > maxMonthsData.length ?  maxMonthsData =  Object.keys(data[index]) : maxMonthsData;
                return  maxMonthsData;
            });
            maxMonthsData.map(_ => {
                this.finalData = {
                    ...this.finalData,
                    [_]: {
                        month: _
                    }
                };
                keys.map(__ => {
                    if(data[__] && data[__][_]) {
                        this.finalData[_][__] = data[__][_];
                    } else {
                        this.finalData[_][__] = 0;
                    }
                });
            });
            this.generateStatementSpreadsheet();
        }

        return (
            <div className="spreadsheet-table">
                <Datasheet
                    valueRenderer={cell => isNaN(cell.value)
                        ? cell.value
                        : Number(cell.value).toLocaleString("en-IN")
                    }
                    data={this.state.data}
                />
            </div>
        );
    }

    onStatementDwnld(reqId){
        CaseService.downloadBankStatementReport(reqId).then(_ => {
            var blob = new Blob([_.data], { type: "octet/stream" });
            var elem = window.document.createElement("a");
            elem.href = window.URL.createObjectURL(blob);
            elem.download = `${reqId}_bank_statement.zip`;
            document.body.appendChild(elem);
            elem.click();
            document.body.removeChild(elem);
            message.success("File Download Successfully");
        }).catch(() => {
            console.log("failed");
        });
    }

    onSucFailStatementDwnld(reqId){
        CaseService.downloadBankStatementErrReport(reqId).then(_ => {
            console.log("_", _.data);
            var blob = new Blob([_.data], { type: "application/vnd.ms-excel" });
            var elem = window.document.createElement("a");
            elem.href = window.URL.createObjectURL(blob);
            elem.download = `${reqId}_bank_statement_analysis.xlsx`;
            document.body.appendChild(elem);
            elem.click();
            document.body.removeChild(elem);
            message.success("File Download Successfully");
        }).catch(() => {
            console.log("failed");
        });
    }
    editActionBankStatement = (k, val) => {
        const keyObj = {
            sixMonthAvgInwardBouncingPercent: "inward_cheque_bounce",
            sixMonthAvgOutwardBouncingPercent: "outward_cheque_bounce",
            monthlyNumberOfContraEmi: "no_emi_bounce"
        };
        let finalBody = keyObj[k] && {[keyObj[k]]: val};
        try{
            CaseService.updateBankStatementChequeData(this.state.selectedJob, finalBody).then(res=>{
                res.status === 200 && this.setState({updatedChequeval:{
                    ...this.state.updatedChequeval,
                    [k]:val}}), message.success(res.data.message);
            }).catch((err) => {
                return Object.values(err) && message.error(Object.values(err)[0]);
            });  
        }catch (e) {
            message.error("Error in triggering");
        }
    }
    getListOfJobs = () => {
        const { bankStatementAnalyser } = this.props;
        const stats = bankStatementAnalyser && bankStatementAnalyser.getIn(["statementAnalysis", this.state.selectedJob, "data"]);
        let analysisMap = {
            sixMonthAvgInwardBouncingPercent: stats && (stats.sixMonthAvgInwardBouncingPercent || stats.overallAvgInwardBouncingPercent),
            sixMonthAvgOutwardBouncingPercent: stats && (stats.sixMonthAvgOutwardBouncingPercent || stats.overallAvgOutwardBouncingPercent),
            monthlyCreditRunningAvgWithReturns: stats && (stats.monthlyCreditRunningAvgWithReturns),
            monthlyDebitRunningAvgWithReturns: stats && (stats.monthlyDebitRunningAvgWithReturns),
            monthlyNumberOfContraEmi: stats && (stats.monthlyNumberOfContraEmi),
            monthlyAvgBalance: stats && (stats.monthlyAvgBalance)
        };
        return (
            <Card
                className={"padless-card"}
                extra={!this.props.isSummary ? [
                    <Button onClick={this.toggleUploadModal} disabled={this.props.recreditViewOnlyPermission} key={"upload"} type={"primary"} icon={"upload"}>
                        {"Upload Bank Statements"}
                    </Button>
                ] : null}
            >
                <div className={"p-10 d-flex flex-row justify-content-space-between"}>
                    {this.ANALYSIS_LIST.map((_, k) => {
                        return(
                            <Col key={_.label}>
                                <Statistic
                                    key={k}
                                    style={{
                                        marginRight: "10px"
                                    }}
                                    title={this.getTitle(_.label, _.formula)}
                                    // className={_.getClassName && _.getClassName()}
                                    valueStyle={{display:"none"}}
                                />
                                <Paragraph style={{marginBottom:"0", fontSize:"22px", lineHeight:"1", color:"rgb(86 84 84 / 85%)"}}
                                    editable={ 
                                        (this.props.adminGroup?.includes(7) && ["sixMonthAvgInwardBouncingPercent","sixMonthAvgOutwardBouncingPercent","monthlyNumberOfContraEmi"].includes(k)) && !this.props.recreditViewOnlyPermission ? 
                                            {
                                                onChange: (val) => {
                                                    this.editActionBankStatement(k, val);
                                                }
                                            } 
                                            : false
                                    }
                                    className={"d-flex"}
                                    level={4}
                                >
                                    {
                                        this.state.updatedChequeval[k] && Number(this.state.updatedChequeval[k])?.toFixed(2) || ((analysisMap[k] || analysisMap[k] === 0) ? analysisMap[k].toFixed(2) : "--")
                                    }
                                </Paragraph>
                            </Col>);}
                    ).toList().toArray()}
                </div>
                {this.props.bankCode === "USFB" ? this.getAnalysisData() : null}
                {!this.props.isSummary ? (
                    <Table
                        columns={this.JobListCols}
                        data={(bankStatementAnalyser.getIn(["jobList", "data"]) || new List([])).sort((a, b) => b.create_date - a.create_date).map(_ => {
                            let row = _;
                            if(_.current_status == 5) {
                                row.action = (
                                    <Button type={"link"} disabled={this.props.recreditViewOnlyPermission} onClick={this.action.bind(null, _.analysis_request)}>{"Use"}</Button>
                                );
                            } else if(_.current_status == 4){
                                row.action = (
                                    <Button type={"link"} disabled={this.props.recreditViewOnlyPermission} onClick={() => this.toggleUploadModal()}>{"Re-upload"}</Button>
                                );
                            }else {
                                row.action = (
                                    <Button type={"link"} disabled={this.props.recreditViewOnlyPermission} onClick={_.provider?this.props.retryAnalysisPerfios.bind(null, this.props.caseId, _.analysis_request):this.props.retryAnalysis.bind(null, this.props.caseId, _.analysis_request)}>{"Retry"}</Button>
                                );
                            }
                            row.download = (
                                <a 
                                    onClick={() => _.provider?this.onStatementDwnld(_.analysis_request):null}
                                    href={_.provider?null:`${process.env.BASE_URL}/statement_analyzer/bank-statement/download/?request_id=${_.analysis_request}`} 
                                    download
                                >
                                    Download
                                </a>
                            );
                            row.error = (
                                _.current_status !==  3 && _.current_status !==  2 && _.current_status !==  1 ?
                                    <a
                                        onClick={() => this.onSucFailStatementDwnld(_.analysis_request)}
                                        download
                                    >
                                        Download</a> : "----"
                            );
                            return row;
                        })}
                        title={"Jobs List"}
                        showFilters={false}
                        showColumnSelector={false}
                        noRowSelection={true}
                    />
                ) : null}
            </Card>
        );
    }

    onTabChange = (key) => {
        this.setState({
            activeKey: key
        });
    }

    handlePerfiosSelect(value){
        if(value == "Finnov"){
            CaseService.getMasterBankListPerfios("Finnov").then(_ => {
                this.setState({
                    banks: _.data
                });
            }).catch(() => {});
            this.setState({
                perfios: false
            });
        }else{
            CaseService.getMasterBankListPerfios("Perfios").then(_ => {
                this.setState({
                    perfiosBanks: _.data
                });
            }).catch(() => {});
            this.setState({
                perfios: true
            });
        }
    }

    render() {
        const { bankStatementAnalyser } = this.props;
        let isJob = bankStatementAnalyser.getIn(["jobList", "data"]).size;
        return (
            <React.Fragment>
                <Modal
                    visible={this.state.uploadFiles}
                    destroyOnClose={true}
                    closable={true}
                    footer={null}
                    onCancel={this.toggleUploadModal}
                >
                    <h3>Select Provider: </h3>
                    <Select style={{width: "140px"}} defaultValue="Perfios" onChange={(value) => this.handlePerfiosSelect(value)}>
                        <Select.Option value="Perfios">Perfios</Select.Option>
                        {/* <Select.Option value="Finnov">Finnov</Select.Option> */}
                    </Select>
                    <Tabs className={"statement-analysis-modal"} style={{marginTop: "20px"}} defaultActiveKey={"1"} onChange={this.onTabChange}>
                        <TabPane tab={"Auto"} key={"1"}>
                            {
                                this.state.perfios ? <BankStatementUploadFormPerfios
                                    banks={this.state.perfiosBanks}
                                    onSubmit={this.uploadBankStatements}
                                    analysisTypeList={this.state.analysisTypeList}
                                    recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                                /> : <BankStatementUploadForm
                                    banks={this.state.banks}
                                    onSubmit={this.uploadBankStatements}
                                    analysisTypeList={this.state.analysisTypeList}
                                    recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                                />
                            }
                        </TabPane>
                        {
                            this.state.perfios ? null:<TabPane tab={"Manual"} key={"2"}>
                                <BankStatementMannualForm
                                    analysisTypeList={this.state.analysisTypeList}
                                    onSubmit={this.submitAnalysisDetail}   
                                />
                            </TabPane>
                        }        
                    </Tabs>
                </Modal>
                {isJob ? this.getListOfJobs() : this.getNoDataCard()}
            </React.Fragment>
        );
    }
}

BankStatementAnalyser.propTypes = {
    createRequest: PropTypes.func,
    createProfiosRequest: PropTypes.func,
    fetchJobsList: PropTypes.func,
    fetchJobsDetails: PropTypes.func,
    fetchStatementAnalysis: PropTypes.func,
    retryAnalysis: PropTypes.func,
    retryAnalysisPerfios: PropTypes.func,
    caseId: PropTypes.number,
    companyId: PropTypes.number,
    bankStatementAnalyser: PropTypes.object,
    isSummary: PropTypes.bool,
    bankCode: PropTypes.string,
    fetchJobsDetailsPerfois: PropTypes.func,
    fetchStatementAnalysisPerfois: PropTypes.func,
    adminGroup: PropTypes.object,
    recreditViewOnlyPermission: PropTypes.object,
};

export default (BankStatementAnalyser);